export default __webpack_public_path__ + "static/media/info.cb17801f.svg";